module.exports = __webpack_public_path__ + "static/media/Online-Payment-Paid.72cce2b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/payments/Online-Payment-Paid.png
// module id = 122
// module chunks = 0